import auth from '../middleware/auth';

export default {
    path: 'profils',
    name: 'user-profile',
    meta: {
        middleware: [auth],
    },
    component: () => import('@/views/site/Profile'),
}